{
  "createLocation": {},
  "createOrder": {},
  "createColocation": {},
  "dropdown": {
    "createTicket": {},
    "createOrderSet": {},
    "createColocationSet": {},
    "createTicketSet": {}
  }
}
